import { ROUTES } from '@/constants';

export const TITLES = {
  [ROUTES.AUTH.LOGIN]: 'Login',
  [ROUTES.AUTH.INVITATION]: 'Welcome to Lilypad',
  [ROUTES.AUTH.RECOVER]: 'Password Recovery',
  [ROUTES.AUTH.RESET_NOTIFICATION]: '',
  [ROUTES.AUTH.RESET_PASSWORD]: 'Reset password',
};
